import { useEffect } from "react";

export const SITE_ORIGIN = "https://zhutiehulan.cn";
export const SITE_NAME = "爆料91";

interface SeoInput {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  type?: string;
  image?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({
  title,
  description,
  keywords,
  path = "/",
  type = "website",
  image,
  jsonLd,
}: SeoInput) {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : "";
  const url = `${SITE_ORIGIN}${path}`;
  const resolvedImage =
    image ||
    "https://readdy.ai/api/search-image?query=Warm%20editorial%20abstract%20background%20with%20layered%20cream%20paper%20texture%20and%20vermilion%20amber%20brush%20strokes%2C%20soft%20cinematic%20light%2C%20modern%20magazine%20cover%20aesthetic&width=1200&height=630&seq=og-cover-91&orientation=landscape";

  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", "index, follow, max-image-preview:large");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", resolvedImage);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", resolvedImage);

    const SCRIPT_ID = "page-jsonld";
    const existing = document.getElementById(SCRIPT_ID);
    if (jsonLdStr) {
      const script =
        existing instanceof HTMLScriptElement
          ? existing
          : document.createElement("script");
      script.id = SCRIPT_ID;
      script.setAttribute("type", "application/ld+json");
      script.text = jsonLdStr;
      if (!script.parentNode) document.head.appendChild(script);
    } else if (existing) {
      existing.remove();
    }
  }, [title, description, keywords, url, type, resolvedImage, jsonLdStr]);
}